<template>

<div>
  <section class="qa-image">
      <img src="@/assets/img/post_paid.png" />
  </section>
  <section>
    <div class="section_title">
      <h1 class="">後払いのよくあるご質問</h1>
    </div>
    <h3 class="mt-5">後払いについて</h3>
    <dl class="list-qa">
      <dt v-on:click="openInfo('1')" :class="{'is-active': isActive[1]}">請求書はどこに届きますか？</dt>
      <dd v-show="isActive[1]">
        請求書は、<span class="font-bold">ご注文者様の登録住所</span>へ郵送いたします。<br>
        商品のお届け先とは異なる場合がございますので、ご登録の住所をご確認ください。
      </dd>
      <dt v-on:click="openInfo('2')" :class="{'is-active': isActive[2]}">請求書はいつ頃届きますか？</dt>
      <dd v-show="isActive[2]">
        商品発送後、1週間ほどで請求書が届けられます。<br>
        ※普通郵便のため、土日・祝日を挟む場合はお届けまでにお時間をいただく場合がございます。
      </dd>
      <dt v-on:click="openInfo('3')" :class="{'is-active': isActive[3]}">支払期限はいつまでですか？</dt>
      <dd v-show="isActive[3]">
        請求書の発行日から<span class="font-bold">14日以内</span>です。<br>
        正確なお支払い期限日は請求書に記載されていますので、必ずご確認ください。<br>
        <span style="color:#A52A2A">※ 2026年3月13日発行分より、<span class="font-bold">支払期限が「発行日から21日後」</span>へ変更となります。</span>
      </dd>
      <dt v-on:click="openInfo('4')" :class="{'is-active': isActive[4]}">支払いが遅れた場合はどうなりますか？</dt>
      <dd v-show="isActive[4]">
        後払いの与信が承認されなくなり、以降<span class="font-bold">サービスをご利用いただけなくなる</span>可能性がございます。必ず期限内のお支払いをお願いいたします。
      </dd>
      <dt v-on:click="openInfo('5')" :class="{'is-active': isActive[5]}">利用限度額はありますか？</dt>
      <dd v-show="isActive[5]">
        後払いのご利用限度額は、累計で**55,000円（税込）**までとなります。<br>
        ※他店での「後払い.com」ご利用分も合算されます。お支払いが完了すると、その分の枠が再び利用可能になります。
      </dd>
      <dt v-on:click="openInfo('6')" :class="{'is-active': isActive[6]}">エラーが出て利用できません。なぜでしょうか？</dt>
      <dd v-show="isActive[6]">
        恐れ入りますが、審査内容については当店で詳細をお調べすることができません。<br>
        お手数ですが、下記カスタマーセンターへ直接お問い合わせください。<br>
        <span class="font-bold">【後払い.com カスタマーセンター】</span><br>
        電話：03-4326-3600（9:00～18:00）<br>
        URL：<a href="https://atobarai-user.jp/contact/" target="_blank">https://atobarai-user.jp/contact/</a>
      </dd>
      <dt v-on:click="openInfo('7')" :class="{'is-active': isActive[7]}">後払いの請求書が送られてきました。どこで支払えますか。</dt>
      <dd v-show="isActive[7]">
        お支払い方法は次のとおりです。<br>
        【窓口でのお支払い】 コンビニエンスストア、MMK設置店<br>
          ※ 窓口では現金でお支払いください。<br>
          ※ お近くのMMK設置店は、以下の一覧からご確認ください。<br>
          <a href="https://www.shinkin-sis.co.jp/mmk/" target="_blank">https://www.shinkin-sis.co.jp/mmk/</a><br><br>
        【振込】 銀行、ゆうちょ銀行 ※ 窓口ではお支払いできません。<br><br>
        【スマートフォンでのお支払い】   ファミリーマート請求書支払、楽天銀行コンビニ支払サービス<br><br>
        ※ クレジットカードで直接お支払いできませんので、ご注意ください。
      </dd>
    </dl>
  </section>
</div>
</template>

<style scoped>
.font-bold {
  font-weight: bold;
}
.qa-image {
  margin-bottom: 50px;
}
</style>

<script>
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 100; i++) {
        this.isActive[i] = false
    }
  },
  methods: {
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = !this.isActive[ref]
      console.log(this.isActive[ref])
    },
  }
}
</script>